import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { setFilteredUsersFromApi } from '../../store/usersReducer';
// import { fetchFilteredUsersList } from '../../asyncActions/fetchFilteredUsers';
import TextField from '../text-field/TextField';

const Search = ({ value, userId, groupId, placeholder, onChange, sx }) => {
  const dispatch = useDispatch();
  const [debouncedText, setDebouncedText] = useState(value);

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedText(value);
    }, 500);

    return () => {
      clearTimeout(timerId);
    };
  }, [value]);

  useEffect(() => {
    if (value === '') {
      dispatch(setFilteredUsersFromApi([]));
    }

    if (userId && groupId && value) {
      // dispatch(fetchFilteredUsersList(userId, groupId, value));

      // Temporary placeholder
      console.log({ userId, groupId, value });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedText]);

  return (
    <TextField
      id="search-in-groups"
      placeholder={placeholder}
      value={value}
      size="small"
      onChange={onChange}
      sx={{
        maxWidth: '300px',
        ...sx,
      }}
    />
  );
};

export default Search;
